<div class="container">
  <div class="gap-4 align-items-stretch">
    <!-- Identifier -->
    <div class="hgap-4">
      <vitamui-select
        class="w-100"
        [formField]="criteriaForm.ruleIdentifier"
        [options]="ruleOptions()"
        [multiple]="true"
        [placeholder]="config.fieldIdPlaceholder | translate"
        [searchBarPlaceHolder]="config.fieldIdSearchPlaceholder | translate"
      >
      </vitamui-select>
      <div class="w-100">
        @if (isAppraisal()) {
          <vitamui-common-editable-input
            class="w-100"
            [formField]="criteriaForm.ruleEliminationIdentifier"
            [label]="'ARCHIVE_SEARCH.SEARCH_CRITERIA_FILTER.FIELDS.ELIMINATION_TECHNICAL_ID' | translate"
          >
          </vitamui-common-editable-input>
        }
      </div>
    </div>

    <!-- Dates -->
    <div class="gap-2 align-items-stretch">
      <div class="text medium bold primary uppercase">
        {{ config.fieldEndDateLabel | translate }}
      </div>

      <div class="hgap-4">
        <vitamui-datepicker
          class="w-100"
          [label]="(endDateInterval ? config.fieldEndDateBeginLabel : config.fieldEndDateEqualLabel) | translate"
          [formField]="criteriaForm.ruleStartDate"
          [max]="criteriaForm.ruleEndDate().value()"
          outputType="Date"
          format="dd/MM/yyyy"
        ></vitamui-datepicker>

        <div class="w-100 hgap-4">
          @if (!endDateInterval) {
            @if (criteriaForm.ruleStartDate().value()) {
              <button class="btn btn-circle default medium secondary" (click)="addBeginDtCriteria()">
                <i class="material-icons">check</i>
              </button>
            }

            <button class="btn link" (click)="updateEndDateInterval(true)">
              {{ config.createIntervalLabel | translate }}
            </button>
          } @else {
            <vitamui-datepicker
              [label]="config.fieldEndDateEndLabel | translate"
              [formField]="criteriaForm.ruleEndDate"
              [min]="criteriaForm.ruleStartDate().value()"
              outputType="Date"
              format="dd/MM/yyyy"
              class="w-100"
            ></vitamui-datepicker>
            @if (criteriaForm.ruleStartDate().value() && criteriaForm.ruleEndDate().value()) {
              <button class="btn btn-circle default medium secondary" (click)="addIntervalDtCriteria()">
                <i class="material-icons">check</i>
              </button>
            }

            <button class="btn link" (click)="updateEndDateInterval(false)">
              {{ config.deleteIntervalLabel | translate }}
            </button>
          }
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="gap-2 w-100">
        <div class="text medium bold primary uppercase">
          {{ config.translationPrefix + 'ORIGIN.TITLE' | translate }}
        </div>

        @for (checkbox of originCheckboxes; track checkbox.key) {
          <vitamui-management-rule-checkbox
            [label]="config.translationPrefix + checkbox.labelKey"
            [field]="checkbox.key"
            [checked]="additionalCriteria.get(checkbox.key)"
            [config]="checkboxConfig[checkbox.key]"
            [ruleType]="ruleType"
            [searchCriteriaType]="searchCriteriaType"
            (changed)="onCheckboxChange(checkbox.key, $event)"
          >
          </vitamui-management-rule-checkbox>
        }
      </div>

      <div class="gap-2 w-100 flex-row">
        @if (finalActionCheckboxes?.length) {
          <div class="gap-2 w-100">
            <div class="text medium bold primary uppercase">
              {{ config.translationPrefix + 'ORIGIN.TITLE' | translate }}
            </div>

            @for (checkbox of finalActionCheckboxes; track checkbox.key) {
              <vitamui-management-rule-checkbox
                [label]="config.translationPrefix + checkbox.labelKey"
                [field]="checkbox.key"
                [checked]="additionalCriteria.get(checkbox.key)"
                [config]="checkboxConfig[checkbox.key]"
                [ruleType]="ruleType"
                [searchCriteriaType]="searchCriteriaType"
                (changed)="onCheckboxChange(checkbox.key, $event)"
              >
              </vitamui-management-rule-checkbox>
            }
          </div>
        }

        @if (finalActionTypeCheckboxes?.length) {
          <div class="gap-2 w-100">
            <div class="text medium bold primary uppercase">
              {{ config.translationPrefix + 'FINAL_ACTION.TITLE' | translate }}
            </div>

            @for (checkbox of finalActionTypeCheckboxes; track checkbox.key) {
              <vitamui-management-rule-checkbox
                [label]="config.translationPrefix + checkbox.labelKey"
                [field]="checkbox.key"
                [checked]="additionalCriteria.get(checkbox.key)"
                [config]="checkboxConfig[checkbox.key]"
                [ruleType]="ruleType"
                [searchCriteriaType]="searchCriteriaType"
                (changed)="onCheckboxChange(checkbox.key, $event)"
              >
              </vitamui-management-rule-checkbox>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
